var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_19049",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 19049",
    transform: "translate(-32 -283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8_182",
    "data-name": "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8 182",
    transform: "translate(32.75 283.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_7998",
    "data-name": "\\u30D1\\u30B9 7998",
    d: "M6.267,16.488,0,10.358,1.867,8.449l4.379,4.284L16.612,2.367,18.5,4.255Z",
    transform: "translate(0 -0.208)",
    fill: "#A59785"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13047",
    "data-name": "\\u30D1\\u30B9 13047",
    d: "M.033.033h18.5v18.5H.033Z",
    transform: "translate(-0.033 -0.033)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_11197",
    "data-name": "\\u9577\\u65B9\\u5F62 11197",
    width: 20,
    height: 20,
    transform: "translate(32 283)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckinIcon);
export default __webpack_public_path__ + "static/media/checkin_icon.67c0ad5317011a9d70a03605ff34a7de.svg";
export { ForwardRef as ReactComponent };